import MarketingLayout from '../components/MarketingLayout';
import LegalPage from '../components/LegalPage';

export default function Terms() {
  return (
    <MarketingLayout
      title="Terms - 10X Planner App"
      description="Terms of service for 10X Planner App."
      canonical="/terms"
    >
      <LegalPage heading="Terms of Service">
        <p>
          By using 10X Planner App (the &quot;service&quot;), you agree to be bound by these terms
          and conditions. 10X Planner App reserves the right to update and change these terms
          without notice. Violation of any of the terms below may result in termination of your
          account.
        </p>

        <h3>Account Terms</h3>
        <p>
          You are responsible for maintaining the security of your account and login credentials.
          We cannot and will not be liable for loss or damage from your failure to comply with this
          security obligation.
        </p>
        <p>
          You are responsible for all content posted and activity that occurs under your account.
          You may not use the service for any illegal purpose or to violate any laws in your
          jurisdiction.
        </p>
        <p>
          You must provide a valid email address and any other information requested in order to
          complete signup. Your login may only be used by one person. You must be a human; accounts
          registered by bots or automated methods are not permitted.
        </p>

        <h3>Payment, Refunds, Upgrading, and Downgrading</h3>
        <p>
          The service is offered with a 14-day free trial. After the trial ends, you must pay in
          advance to continue using paid features. If payment fails, your account may be downgraded
          or restricted until payment is made.
        </p>
        <p>
          Downgrading or canceling your service may cause loss of features or capacity. We do not
          accept liability for such loss. Fees are exclusive of taxes, levies, or duties imposed by
          taxing authorities unless otherwise stated.
        </p>
        <p>Refunds are processed according to our fair refund policy.</p>

        <h3>Cancellation and Termination</h3>
        <p>
          You are responsible for properly canceling your account or subscription. You can cancel
          through the billing portal made available inside the application. Email requests are not
          considered cancellation unless we explicitly confirm cancellation in writing.
        </p>
        <p>
          Upon cancellation, your access to paid features may end immediately or at the end of the
          current billing period depending on Stripe billing state and product configuration.
        </p>
        <p>
          We reserve the right to suspend or terminate your account and refuse current or future use
          of the service for any reason at any time.
        </p>

        <h3>Modifications to the Service and Prices</h3>
        <p>
          We reserve the right to modify or discontinue any part of the service, temporarily or
          permanently, with or without notice. Prices may change with notice posted on the service
          or website.
        </p>

        <h3>Copyright and Content Ownership</h3>
        <p>
          We claim no intellectual property rights over the material you provide to the service.
          Your planning entries and other user-generated content remain yours.
        </p>
        <p>
          The look and feel of the service is copyright 10X Planner App. You may not duplicate,
          copy, or reuse any portion of the HTML, CSS, JavaScript, or visual design elements
          without express written permission.
        </p>

        <h3>General Conditions</h3>
        <p>
          Your use of the service is at your sole risk. The service is provided on an &quot;as
          is&quot; and &quot;as available&quot; basis. We do not warrant that the service will meet
          your specific requirements, be uninterrupted, be secure, or be error-free.
        </p>
        <p>
          You understand that we use third-party vendors and hosting partners to provide the
          hardware, software, networking, storage, payment processing, email, and related technology
          required to run the service.
        </p>
        <p>
          Questions about these terms should be sent to{' '}
          <a href="mailto:10xplannerapp@gmail.com">10xplannerapp@gmail.com</a>.
        </p>
      </LegalPage>
    </MarketingLayout>
  );
}
